import type { SortOrder } from '../../types';

/**
 * Compares two given items by specified order,
 * and returns zero, positive, or negative number
 */
const compareItems = <TItem>(x: TItem, y: TItem, order: SortOrder): number => {
  if (typeof x === 'string' && typeof y === 'string') {
    return order === 'asc'
      ? x.localeCompare(y, undefined, { numeric: true })
      : y.localeCompare(x, undefined, { numeric: true });
  }
  if (typeof x === 'number' && typeof y === 'number') {
    return order === 'asc' ? x - y : y - x;
  }

  return 0;
};

export default compareItems;
